import i18n from 'i18next';

// Its own namespace: AppRouter and RouteSkeleton draw the skeletons, so they are in the initial
// bundle and must not pull the feature's copy (../../i18n) in with them.
export const NS = 'integrations-skeleton';

export const en = {
  providers: 'Loading integrations',
  tools: 'Loading skill tools',
};
export const es: typeof en = {
  providers: 'Cargando integraciones',
  tools: 'Cargando skill tools',
};
export const pt: typeof en = {
  providers: 'Carregando integrações',
  tools: 'Carregando skill tools',
};

// Guarded so importing this is safe where the i18next singleton isn't initialized (jest).
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
